import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnWS: CultureInfo = {
  name: 'en-WS',
  displayName: 'English (Samoa)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-WS',
  parent: CultureInfoEn
};
